<div class="flex--row gap--8">
  <div
    class="flex--row gap--8 selected-team-wrapper"
    *ngIf="selectedTeamDOM"
    (click)="onRemove()"
  >
    {{ selectedTeamDOM?.name }}
    <mat-icon style="transform: scale(0.8)" *ngIf="canRemoveFilter"
      >close</mat-icon
    >
  </div>

  <button color="accent" mat-icon-button [matMenuTriggerFor]="teamMenu">
    <mat-icon>
      <span
        [ngClass]="{
          'material-icons': selectedTeamDOM,
          'material-icons-outlined': !selectedTeamDOM
        }"
      >
        filter_alt
      </span>
    </mat-icon>
  </button>
  <mat-menu
    #teamMenu="matMenu"
    xPosition="before"
    [backdropClass]="'backdrop'"
  >
    <div class="search-wrapper">
      <ng-bee-w-h-search-term-util
        (click)="$event.stopPropagation()"
        [focusElement]="true"
        [isCharTriggerLimited]="false"
        (onSearchTermInput)="onSearchTerm($event)"
      >
      </ng-bee-w-h-search-term-util>
    </div>
    <div class="mat-menu-items-wrapper">
        <button
        mat-menu-item
        (click)="onSelect(team)"
        *ngFor="let team of filteredTeamList"
      >
        <div class="flex--r-c-sb gap--4 flex-1">
          <span>{{ team.name }}</span>
          <mat-icon
            style="transform: scale(0.8)"
            *ngIf="selectedTeamDOM?.id === team.id"
            >done</mat-icon
          >
        </div>
      </button>
    </div>
  </mat-menu>
</div>
